import type { FinisherCardDescriptor } from '@/types/finisher'

export const FINISHER_CARDS: FinisherCardDescriptor[] = [
  {
    id: 'funny',
    label: 'Bonk!',
    icon: '💫',
    durationMs: 3000,
    unlockHint: 'Always available',
    isUnlocked: () => true,
  },
  {
    id: 'brutality',
    label: 'Smash!',
    icon: '💥',
    durationMs: 4200,
    unlockHint: 'Win with ≥50% HP',
    isUnlocked: (s) => s.hpRetainedPct >= 50,
  },
  {
    id: 'animality',
    label: 'Beast!',
    icon: '🐾',
    durationMs: 3600,
    unlockHint: 'Flawless win or final combo ≥3',
    isUnlocked: (s) => s.flawless || s.finalComboHits >= 3,
  },
]

export const DEFAULT_FINISHER_ID = 'funny' as const

export const CHOOSE_TIMEOUT_MS = 7000
export const STUN_DURATION_MS = 800
export const ANNOUNCE_DURATION_MS = 700
export const CARDS_RISE_DURATION_MS = 500
// Flash phase covers (a) mint flash bg fade-out and (b) VICTORY/DEFEAT stamp
// slam + brief hold before the result screen mounts. Long enough to be read.
export const FLASH_DURATION_MS = 850
